// Mock data para APA INFORMÁTICA

export const produtos = [
  {
    id: 1,
    nome: "Notebook Gamer Avell",
    descricao: "Ideal para trabalhos com softwares pesados e jogos pesados",
    processador: "Intel® Core™ i7-9750H",
    placa_video_integrada: "Intel® UHD Graphics 630",
    placa_video_dedicada: "NVIDIA GeForce GTX 1660 Ti - 6GB",
    ram: "16GB DDR4",
    armazenamento: "SSD M.2 480GB",
    tela: "15.6\" Full HD",
    teclado_numerico: "Sim",
    preco_vista: 3990.00,
    preco_parcelado: 4380.00,
    parcelas: 6,
    imagens: [
      "https://customer-assets.emergentagent.com/job_computech-bh/artifacts/wdusvarj_WhatsApp%20Image%202025-12-11%20at%2012.47.52.jpeg",
      "https://customer-assets.emergentagent.com/job_computech-bh/artifacts/l05ph8s1_WhatsApp%20Image%202025-12-11%20at%2012.47.5111.jpeg",
      "https://customer-assets.emergentagent.com/job_computech-bh/artifacts/yaltqntk_WhatsApp%20Image%202025-12-11%20at%2012.47.5222.jpeg"
    ],
    imagem: "https://customer-assets.emergentagent.com/job_computech-bh/artifacts/wdusvarj_WhatsApp%20Image%202025-12-11%20at%2012.47.52.jpeg"
  },
  {
    id: 2,
    nome: "Notebook Lenovo",
    descricao: "Performance e qualidade Lenovo",
    processador: "Intel® Core™ i5-8250U",
    placa_video_integrada: "Intel® HD Graphics 620",
    ram: "08GB DDR4",
    armazenamento: "SSD 240GB",
    tela: "14\" Full HD",
    preco_vista: 1490.00,
    preco_parcelado: 1650.00,
    parcelas: 6,
    imagem: [
      "https://i.imgur.com/Znb7qQJ.jpeg",
      "https://i.imgur.com/Kcy0frE.jpeg",
      "https://i.imgur.com/qnZ8Fkv.jpeg"
    ],
    imagem: "https://i.imgur.com/Znb7qQJ.jpeg"       
  },
  {
    id: 3,
    nome: "MacBook Air (13 polegadas, 2017)",
    descricao: "Elegância e desempenho Apple",
    processador: "Intel® Core™ i5 - 1,8 GHz (Turbo Boost de até 2,9 GHz)",
    placa_video_integrada: "Intel® HD Graphics 6000",
    ram: "08GB DDR3",
    armazenamento: "Macintosh HD 220GB",
    tela: "13\" Full HD",
    preco_vista: 2190.00,
    preco_parcelado: 2350.00,
    parcelas: 6,
    imagem: [
      "https://i.imgur.com/hCmQnwR.jpeg",
      "https://i.imgur.com/ChBOnM9.jpeg",
      "https://i.imgur.com/WThlz3e.jpeg"
    ],
    imagem: "https://i.imgur.com/hCmQnwR.jpeg"
  },
  {
    id: 4,
    nome: "COMPUTADOR EMPRESARIAL HP COMPAQ ELITE 8300",
    descricao: "Ideal para uso corporativo",
    processador: "AMD Phenom II x4 B97 3.2GHZ (Equivale a um i3-3º geração ou i5-1º geração)",
    ram: "08GB DDR3",
    armazenamento: "SSD 120GB",
    preco_vista: 590.00,
    preco_parcelado: 640.00,
    parcelas: 6,
    imagem: "https://i.imgur.com/ILVbM7O.jpeg"
  },
  {
    id: 5,
    nome: "COMPUTADOR EMPRESARIAL HP COMPAQ ELITE 8300",
    descricao: "Performance empresarial aprimorada",
    processador: "Intel® Core™ i5-3570 3.4GHZ",
    ram: "08GB DDR3",
    armazenamento: "SSD 120GB",
    preco_vista: 790.00,
    preco_parcelado: 850.00,
    parcelas: 6,
    imagem: "https://i.imgur.com/ILVbM7O.jpeg"
  },
  {
    id: 6,
    nome: "Notebook HP I7",
    descricao: "Potência Intel i7",
    processador: "Intel® Core™ i7-7500u",
    placa_video_integrada: "Intel® HD Graphics 620",
    ram: "08GB DDR4",
    armazenamento: "SSD 240GB",
    tela: "15,6\" Full HD",
    teclado_numerico: "Sim",
    observacoes: "Bateria não carrega",
    preco_vista: 1490.00,
    preco_parcelado: 1650.00,
    parcelas: 6,
    imagem: "https://i.imgur.com/TWcL5FK.jpeg"
  },
  {
    id: 7,
    nome: "Notebook Dell Precision",
    descricao: "Ideal para trabalhos com softwares 3D e Jogos Pesados",
    processador: "Intel® Core™ i7-6820HQ",
    placa_video_dedicada: "NVIDIA Quadro M2000M 4GB - GDDR5",
    placa_video_integrada: "Intel® HD Graphics",
    ram: "16GB DDR4",
    armazenamento: "SSD M.2 240GB (Slot para mais um SSD SATA)",
    tela: "15.6\" Full HD",
    teclado_numerico: "Sim",
    preco_vista: 2490.00,
    preco_parcelado: 2640.00,
    parcelas: 6,
    imagem: "https://i.imgur.com/M9Ouk6B.jpeg"
  },
  {
    id: 8,
    nome: "Notebook Dell",
    descricao: "Confiabilidade Dell para o dia a dia",
    processador: "Intel® Core™ i5-5200u",
    placa_video_integrada: "Intel® HD Graphics",
    ram: "08GB DDR3",
    armazenamento: "SSD 120GB",
    tela: "14\" Full HD",
    preco_vista: 990.00,
    preco_parcelado: 1090.00,
    parcelas: 6,
    imagem: "https://i.imgur.com/E9WrMzO.jpeg"
  },
  {
    id: 9,
    nome: "Notebook HP",
    descricao: "Notebook HP confiável",
    processador: "Intel® Core™ i5-6º geração",
    placa_video_integrada: "Intel® HD Graphics",
    ram: "08GB DDR4",
    armazenamento: "SSD 120GB",
    tela: "14\" Full HD",
    preco_vista: 1290.00,
    preco_parcelado: 1380.00,
    parcelas: 6,
    imagem: "https://i.imgur.com/OF88Bw2.jpeg"
  },
  {
    id: 10,
    nome: "Notebook HP",
    descricao: "HP com bom custo-benefício",
    processador: "Intel® Core™ i5-4210u",
    placa_video_integrada: "Intel® HD Graphics",
    ram: "08GB DDR3",
    armazenamento: "SSD 240GB",
    tela: "14\" Full HD",
    preco_vista: 940.00,
    preco_parcelado: 1020.00,
    parcelas: 6,
    imagem: "https://i.imgur.com/OF88Bw2.jpeg"
  },
  {
    id: 11,
    nome: "Notebook Lenovo",
    descricao: "Lenovo econômico e eficiente",
    processador: "Intel® Core™ i5-4210u",
    placa_video_integrada: "Intel® HD Graphics",
    ram: "08GB DDR3",
    armazenamento: "SSD 250GB",
    tela: "14\" Full HD",
    preco_vista: 890.00,
    preco_parcelado: 990.00,
    parcelas: 6,
    imagem: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqvbINPnGt1qhRV926ZjGh5cQNKxS4WHWJ4w&s"
  },
  {
    id: 12,
    nome: "Monitor HQ 24\" Polegadas",
    descricao: "Monitor de alta qualidade para trabalho e entretenimento",
    tela: "24\" Full HD",
    entradas: "HDMI / VGA",
    preco_vista: 340.00,
    preco_parcelado: 340.00,
    parcelas: 2,
    imagem: "https://images4.kabum.com.br/produtos/fotos/340754/monitor-hq-24-led-full-hd-hdmi-vga-vesa-ajuste-de-inclinacao-24hq-led_1659103178_gg.jpg"
  },
  {
    id: 13,
    nome: "Monitor Dell 17\" Polegadas",
    descricao: "Monitor Dell compacto e eficiente",
    tela: "17\" Full HD",
    entradas: "HDMI / VGA",
    preco_vista: 210.00,
    preco_parcelado: 210.00,
    parcelas: 2,
    imagem: "https://http2.mlstatic.com/D_NQ_NP_830549-MLB91182080282_092025-O.webp"
  },
  {
    id: 14,
    nome: "Monitor Tronos 19\" Polegadas",
    descricao: "Monitor Tronos ideal para home office",
    tela: "19\" Full HD",
    entradas: "HDMI",
    preco_vista: 190.00,
    preco_parcelado: 190.00,
    parcelas: 2,
    imagem: "https://images.tcdn.com.br/img/img_prod/1225936/monitor_led_19_tronos_trs_hk19wy_1366768_60hz_5ms_hdmi_vga_preto_29_1_007e2afd35c211556acbc7fc3efa5366.jpg"
  },
  {
    id: 15,
    nome: "Kit Gamer HP",
    descricao: "Kit completo para gamers",
    teclado: "Teclado mecânico Gamer HP LED - Branco",
    mouse: "Mouse Gamer HP - Preto",
    fone: "Fone Gamer HP - Preto",
    mousepad: "Mouse Pad Gamer HP - Preto",
    preco_vista: 340.00,
    preco_parcelado: 340.00,
    parcelas: 2,
    imagem: "https://m.media-amazon.com/images/I/411JQHl-RvS._AC_UF894,1000_QL80_.jpg"
  }
];

export const servicos = [
  {
    id: 1,
    titulo: "Manutenção Preventiva",
    descricao: "Limpeza interna, troca de pasta térmica e otimização do sistema",
    icon: "Wrench",
    preco: "A partir de R$ 70,00"
  },
  {
    id: 2,
    titulo: "Formatação Completa",
    descricao: "Instalação do Windows, drivers e programas essenciais",
    icon: "HardDrive",
    preco: "A partir de R$ 100,00"
  },
  {
    id: 3,
    titulo: "Upgrade de Hardware",
    descricao: "Instalação de SSD, memória RAM e outros componentes",
    icon: "Cpu",
    preco: "A partir de R$ 100,00"
  },
  {
    id: 4,
    titulo: "Remoção de Vírus",
    descricao: "Limpeza completa de malwares e proteção do sistema",
    icon: "Shield",
    preco: "A partir de R$ 80,00"
  },
  {
    id: 5,
    titulo: "Recuperação de Dados",
    descricao: "Recuperação de arquivos perdidos ou corrompidos",
    preco: "Sob consulta"
  },
  {
    id: 6,
    titulo: "Troca de Tela",
    descricao: "Substituição de telas de notebooks com garantia",
    icon: "Monitor",
    preco: "A partir de R$ 150,00"
  },
  {
    id: 7,
    titulo: "Troca de Bateria",
    descricao: "Baterias originais e compatíveis com reciclagem da antiga",
    icon: "Battery",
    preco: "A partir de R$ 180,00"
  },
  {
    id: 8,
    titulo: "Conserto de Placas",
    descricao: "Reparo em nível de componente (BGA, reballing)",
    icon: "CircuitBoard",
    preco: "Sob consulta"
  }
];

export const avaliacoes = [
  {
    id: 1,
    nome: "Leo MCampos",
    foto: "https://lh3.googleusercontent.com/a-/ALV-UjW5cd3YVfkLmtcajEw78GlwSYvite02QxOauLEAaFblTJkmcurWEg=s60-c-rp-mo-br100",
    avaliacao: 5,
    comentario: "Serviço de excelência, levei as peças pra montarem um PC para mim, o setup ficou maravilhoso! Recomendo demais a empresa, parabéns ao Davison e ao Daniel.",
    data: "Há 3 semanas"
  },
  {
    id: 2,
    nome: "Alexandre Batista",
    foto: "https://lh3.googleusercontent.com/a-/ALV-UjUzgVGASPeOQ6FtbMj0oNu59L3r2NPUqKFyzSBXgr5DZMxTn5JfZA=s60-c-rp-mo-br100",
    avaliacao: 5,
    comentario: "Após passar por diversos estabelecimentos que apresentaram diagnósticos equivocados sobre o problema da minha máquina, finalmente encontrei a APA Informática. Desde o primeiro atendimento, demonstraram profissionalismo, transparência e conhecimento técnico, oferecendo uma solução honesta, eficiente e com excelente custo-benefício. Atendimento de confiança, que transmite segurança ao cliente. Recomendo com total tranquilidade.",
    data: "Há 5 semanas"
  },
  {
    id: 3,
    nome: "J. Maia",
    foto: "https://lh3.googleusercontent.com/a-/ALV-UjUt5O0Kx0N9CIayRQvR8IvwwFA5Y5AIXNPfT4JoW-OULBnvzMFE=s60-c-rp-mo-br100",
    avaliacao: 5,
    comentario: "Ótimo atendimento e serviço. Comprei meu notebook com eles pela metade do preço do site!",
    data: "Há 1 semanas"
  },
  {
    id: 4,
    nome: "Marina Lima dos Reis",
    foto: "https://lh3.googleusercontent.com/a/ACg8ocKYAsgYbjwKzjy116bE6fphnMIi9SCHJyQSqMQ9z7C7d6zN-g=s60-c-rp-mo-br100",
    avaliacao: 5,
    comentario: "Excelente atendimento!! Parabéns",
    data: "Há 3 semanas"
  },
   {
    id: 5,
    nome: "Amanda Alkmim",
    foto: "https://lh3.googleusercontent.com/a-/ALV-UjUENFwzIZK8TbJPAsT9_9URRMOOfWYxu6VIoDizkZaWGyuyEueX=s60-c-rp-mo-br100",
    avaliacao: 5,
    comentario: "Comprei uma fonte, produto de qualidade com excelente preço.",
    data: "Há 3 semanas"
  }
];

export const empresa = {
  nome: "APA INFORMÁTICA",
  endereco: {
    rua: "Rua Conceição do Mato Dentro, 320 – Loja 12",
    bairro: "Ouro Preto",
    cidade: "Belo Horizonte",
    estado: "MG",
    cep: "31310-240",
    completo: "Rua Conceição do Mato Dentro, 320 - Loja 12, Ouro Preto, Belo Horizonte - MG, 31310-240"
  },
  contato: {
    telefone: "(31) 3222-7373",
    whatsapp: "5531322273373",
    whatsapp_link: "https://wa.me/553132227373",
    email: "contato@apainformatica.com.br",
    website: "www.apainformatica.com.br",
    instagram: "https://www.instagram.com/apa.informatica/"
  },
  horario: {
    semana: "Segunda a Sexta: 09:00 - 18:00",
    sabado: "Sábado: Fechado",
    domingo: "Domingo: Fechado"
  },
  area_atendimento: "Pampulha e região",
  avaliacao: {
    nota: 5.0,
    total: 9
  },
  sobre: "A APA INFORMÁTICA é uma empresa especializada em assistência técnica, venda de notebooks e computadores em Belo Horizonte. Com mais de 30 anos de experiência, oferecemos soluções completas em informática com qualidade, confiança e preços justos. Nossa equipe é formada por técnicos qualificados que estão prontos para atender suas necessidades com agilidade e profissionalismo.",
  diferenciais: [
    "Mais de 30 anos de experiência",
    "Técnicos qualificados e certificados",
    "Garantia em todos os serviços",
    "Orçamento sem compromisso",
    "Atendimento personalizado",
    "Peças originais e de qualidade"
  ]
};
